import React from 'react'
import { Description, Title } from '../common/System'
import { useUpdateGetApi } from '../../hooks/useUpdate'

type propsType = {
    major: string,
    lv: string,
    section: string,
    formMajorHandler: (e: React.ChangeEvent<HTMLInputElement>) => void,
    formLvHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void,
    formSectionHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void,
    handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void,
}

const ViewProfileSearch = (props: propsType) => {
    const {isLoading, data} = useUpdateGetApi()

  return (
    <div>
        <Title>데이터 보기: 학문프로파일</Title>
        <Description>학문프로파일 데이터를 살펴봅니다. 계열, 영역, 학과검색을 하지 않으면 전체 데이터가 검색됩니다.</Description>
        {isLoading?
            <div></div>
            :
            <Description>마지막 업데이트 일시: {data.updated_at.slice(0,19).replace('T', ' ')}</Description>}
        <div>
            <select name="lv2" onChange={(e) => props.formLvHandler(e)}>
                <option value="">계열 선택하기</option>
                <option value="인문">인문</option>
                <option value="사회">사회</option>
                <option value="법학">법학</option>
                <option value="교육_문과">교육_문과</option>
                <option value="교육_이과">교육_이과</option>
                <option value="교육_예체능">교육_예체능</option>
                <option value="공학">공학</option>
                <option value="농학">농학</option>
                <option value="자연">자연</option>
                <option value="의약">의약</option>
                <option value="예체능">예체능</option>
            </select>
            <select name="section" onChange={(e) => props.formSectionHandler(e)}>
                <option value="">영역 선택하기</option>
                <option value="지식">지식</option>
                <option value="스킬">스킬</option>
                <option value="흥미">흥미</option>
                <option value="가치">가치</option>
                <option value="개인특성">개인특성</option>
                <option value="인접학과">인접학과</option>
            </select>
            <form onSubmit={(e) => props.handleSubmit(e)}>
                <input
                    type="text"
                    id = "major"
                    name = "major"
                    value = {props.major}
                    placeholder=' '
                    onChange={(e) => props.formMajorHandler(e)}
                />
                <label htmlFor='word'>학과를 검색하세요.</label>
                <button>검색</button>
            </form>
        </div>
    </div>
  )
}

export default ViewProfileSearch